
const metaPadrao = {
    subject: ['PROJETO'],
    action: ['read'],
    showMenu: true,
    grupo: "CRE",
    grupoTitle: "CRE"
}

const rotas = {
    geral: [

        {
            path: '/cre',
            name: 'CRE - GERAL',
            component: () => import("@/views/CREObras/DashboardGeral.vue"),
            meta: {
                breadcrumb: '',
                title: "CRE - GERAL",
                icon: 'mdi-text-box-multiple-outline',
                ...metaPadrao
            },
        },

        {
            path: '/cre/Dashboard',
            name: 'CRE Dashboard',
            component: () => import("@/views/CREObras/ListarDashboardGeralObra.vue"),
            meta: {
                breadcrumb: '',
                title: "CRE Dashboard",
                icon: 'mdi-view-dashboard-outline',
                ...metaPadrao,
            action: ['admin_projetos'],
            },
        },
        {
            path: '/cre/AsBuilt',
            name: 'As Built Geral',
            component: () => import("@/views/CREObras/DashboardGeral.vue"),
            meta: {
                breadcrumb: 'CRE - GERAL',
                title: "As Built",
                icon: 'mdi-hexagon-multiple',
                query: { categoria: 'AsBuilt' },
                ...metaPadrao

            },
        },
        {
            path: '/cre/Executivo',
            name: 'Executivo Geral',
            component: () => import("@/views/CREObras/DashboardGeral.vue"),
            meta: {
                breadcrumb: 'CRE - GERAL',
                title: "Executivo",
                icon: 'mdi-hexagon-slice-1',
                ...metaPadrao,
                query: { categoria: 'Executivo' },

            },
        },
        {
            path: '/cre/Referencia',
            name: 'Referência Geral',
            component: () => import("@/views/CREObras/DashboardGeral.vue"),
            meta: {
                breadcrumb: 'CRE - GERAL',
                title: "Referência",
                icon: 'mdi-text-box',
                query: { categoria: 'Referencia' },
                subject: ['PROJETO'],
                action: ['readInterno'],
                showMenu: true,
                grupo: "CRE",
                grupoTitle: "CRE",
            },
        },],
    obra:
        [
            {
                path: 'cre/Dashboard',
                name: 'CRE Dashboard Obra',
                component: () => import("@/views/CREObras/ListarDashboardGeralObra.vue"),
                meta: {
                    breadcrumb: '',
                    title: "CRE Dashboard Obra",
                    icon: 'mdi-view-dashboard-outline',
                    subject: ['PROJETO'],
                    action: ['readInterno'],
                    showMenu: true,
                    grupo: "CRE",
                    grupoTitle: "CRE",
                },
            },
            {
                path: 'cre',
                name: 'Projetos de obra',
                component: () => import("@/views/CREObras/DashboardObra.vue"),
                meta: {
                    breadcrumb: '',
                    title: "Projetos de obra",
                    icon: 'mdi-text-box-multiple-outline',
                    ...metaPadrao
                },
            },
            {
                path: 'cre/AsBuilt',
                name: 'As Built',
                component: () => import("@/views/CREObras/DashboardObra.vue"),
                meta: {
                    breadcrumb: 'Projetos de obra',
                    title: "As Built",
                    icon: 'mdi-hexagon-multiple',
                    query: { categoria: 'AsBuilt' },
                    ...metaPadrao
                },
            },
            {
                path: 'cre/Executivo',
                name: 'Executivo',
                component: () => import("@/views/CREObras/DashboardObra.vue"),
                meta: {
                    breadcrumb: 'Projetos de obra',
                    title: "Executivo",
                    icon: 'mdi-hexagon-slice-1',
                    query: { categoria: 'Executivo' },
                    ...metaPadrao
                },
            },
            {
                path: 'cre/Referencia',
                name: 'Referência',
                component: () => import("@/views/CREObras/DashboardObra.vue"),
                meta: {
                    breadcrumb: 'Projetos de obra',
                    title: "Referência",
                    icon: 'mdi-text-box',
                    query: { categoria: 'Referencia' },
                    subject: ['PROJETO'],
                    action: ['readInterno'],
                    showMenu: true,
                    grupo: "CRE",
                    grupoTitle: "CRE",
                },
            },
        ]
}
export default rotas;